module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_2_m.8578c5a14fa19a19d7f1a416a495c23d.png";